

import respUtility from '@/mixins/respUtility';

export default {
  name: 'ListingProductsListItemDynamics',
  mixins: [respUtility],
  props: {
    product: {
      type: Object,
      required: true,
    },
    dynamicProduct: {
      type: Object,
      required: true,
    },
    initialLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      clickedItem: null,
      currentUrl: this.dynamicProduct.url,
      isMounted: false,
      selectedThumbnailWebId: null,
    };
  },
  computed: {
    formattedDynamics() {
      const count = (!this.isMounted ? this.$device.isMobile : this.isRespSmAndDown) ? 2 : 4;
      if (!(this.product.dynamicAttribute && Array.isArray(this.product.dynamicAttribute.items))) {
        return [];
      }
      if (this.product.dynamicAttribute.items.length <= count) {
        return this.product.dynamicAttribute.items;
      }
      const thisItemIndex = this.product.dynamicAttribute.items
        .findIndex((item) => item.id === this.product.id);
      const copy = thisItemIndex > -1
        ? [...this.product.dynamicAttribute.items].splice(thisItemIndex, 1)
        : [...this.product.dynamicAttribute.items];
      if (thisItemIndex > -1) {
        copy.unshift(this.product.dynamicAttribute.items[thisItemIndex]);
      }
      return copy.slice(0, count);
    },
    formattedDynamicsWithUrls() {
      if (!Array.isArray(this.product.items)) {
        return this.formattedDynamics;
      }
      return this.formattedDynamics.map((item) => {
        const product = this.product.items.find((i) => i.webId === item.webId);
        const alt = product ? product.name : '';
        return {
          ...item,
          slug: product ? product.slug : '',
          alt,
        };
      });
    },
    additional() {
      if (!(this.product.dynamicAttribute && this.product.dynamicAttribute.additional)) {
        return 0;
      }
      return this.product.dynamicAttribute.additional - this.formattedDynamicsWithUrls.length;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  watch: {
    dynamicProduct(newProduct) {
      setTimeout(() => {
        this.currentUrl = newProduct.url;
      }, 0);
    },
  },
  mounted() {
    this.isMounted = true;
    // this.selectedThumbnailWebId = this.formattedDynamicsWithUrls[0]?.webId;
  },
  methods: {
    changeProductInfo(webId) {
      // this.selectedThumbnailWebId = webId;
      // eslint-disable-next-line max-len, vue/max-len
      // setTimeout(() => this.$emit('change-dynamic', webId), !(this.$device.isMobileOrTablet || this.isTouchDevice) ? 0 : 100);
      this.$emit('change-dynamic', webId);
    },
    goToPage(event, thumb) {
      const { slug: url, webId } = thumb;
      if (!url) return;
      if ((this.$device.isMobileOrTablet || this.isTouchDevice)) {
        if (this.clickedItem === url) {
          this.$router.push(url);
          this.clickedItem = null;
          document.removeEventListener('click', this.resetClickedItem);
        } else {
          event.stopPropagation();
          event.preventDefault();
          this.clickedItem = url;
          // this.selectedThumbnailWebId = webId;
          if (webId) {
            this.changeProductInfo(webId);
          }
          document.addEventListener('click', this.resetClickedItem);
        }
      } else {
        this.$router.push(url);
      }
    },
    resetClickedItem(event) {
      if (!this.$el.contains(event.target)) {
        this.clickedItem = null;
        this.selectedThumbnailWebId = null;
        document.removeEventListener('click', this.resetClickedItem);
      }
    },
    goTo(link) {
      if (!link) return;
      this.$router.push(link);
    },
  },
};
